import * as types from './types';

export default {    
    [types.GET_TOTAL_ROWS]: state => {
        return state.totalRows
    },
    [types.GET_PURPOSE_ID]: state => {
        return state.purposeId
    },
    [types.GET_PURPOSE_OTHERS]: state => {
        return state.purposeOthers
    },
    [types.GET_DETAILS_NOTIFICATION]: state => {
        return state.detailsNotification
    },
    [types.GET_NOTIFICATION_ID]: state => {
        return state.notificationId
    },
    [types.GET_MAP]: state => {
        return state.map
    },
    [types.GET_WAYPOINTS]: state => {
        return state.waypoints
    },
    [types.GET_AGENCIES]: state => {
        return state.agencyList
    },
    [types.GET_PURPOSES]: state => {
        return state.purposeList
    },
    [types.GET_AGENCY_OTHERS]: state => {
        return state.agencyOthers
    },
    [types.GET_ATTACHMENTS]: state => {
        return state.attachmentList
    },
    [types.GET_REQUEST_TYPES]: state => {
        return state.requestTypeList
    },
    [types.GET_EMERGENCY_NOTIFICATION]: state => {
        return state.emergencyNotificationList
    },
    [types.GET_STATUSES]: state => {
        return state.statusList
    },
    [types.GET_USER_TOKEN]: state => {
        return state.token
    },
    [types.GET_USERNAME]: state => {
        return state.username
    },
    [types.GET_USER_FIRSTNAME]: state => {
        return state.firstname
    },
    [types.GET_USER_LASTNAME]: state => {
        return state.lastname
    },
    [types.GET_USER_PERMISSION]: state => {
        return state.permission
    },
    [types.GET_USER_AGENCY_ID]: state => {
        return state.agencyId
    },
    [types.GET_USER_AGENCY_NAME]: state => {
        return state.agencyName
    },
    [types.GET_REQUEST_TYPE_ID]: state => {
        return state.requestTypeId
    },
    [types.GET_EHOC_REF]: state => {
        return state.ehocRef
    },
    [types.GET_NV_FOR]: state => {
        return state.nv_for
    },
    [types.GET_NV_NUMBER]: state => {
        return state.nv_number
    },
    [types.GET_ORG_ANONYMOUS]: state => {
        return state.isOrgAnonymous
    },
    [types.GET_SUBMITTED_ID]: state => {
        return state.submittedId
    },
    [types.GET_REQUESTED_BY]: state => {
        return state.requestedBy
    },
    [types.GET_LAST_UPDATED_BY]: state => {
        return state.lastUpdatedBy
    },
    [types.GET_NOTES]: state => {
        return state.notes
    },
    [types.GET_STATUS_ID]: state => {
        return state.statusId
    },
    [types.GET_MODE]: state => {
        return state.mode
    },
    [types.GET_VIEW_MOFA]: state => {
        return state.viewMofa
    },
    [types.GET_MODIFIED]: state => {
        return state.modified
    },
    [types.GET_NEW_NOTIFICATION]: state => {
        return state.new_notification
    },
    [types.GET_MAP_MODIFIED]: state => {
        return state.map_modified
    },
    [types.GET_MAP_INDEX]: state => {
        return state.map_index
    },
    [types.GET_AIR_USAGE]: state => {
        return state.usageList
    },
    [types.GET_AIR_CLEARANCE]: state => {
        return state.clearanceList
    },
    [types.GET_AIR_REQUEST]: state => {
        return state.requestList
    },
    [types.GET_AIR_OPERATOR]: state => {
        return state.operatorList
    },
    [types.GET_NSL_FACILITY_TYPE]: state => {
        return state.facilityTypeList
    },
    [types.GET_NSL_SITE_TYPE]: state => {
        return state.siteTypeList
    },
    [types.GET_START_DATE]: state => {
        return state.start_date
    }//,
    // [types.GET_DEPARTURE_DATE]: state => {
    //     return state.departure_date
    // },
    // [types.GET_ARRIVAL_DATE]: state => {
    //     return state.arrival_date
    // }   
}


// WEBPACK FOOTER //
// ./src/store/getters.js